import { getDeviceRoute, getGroupRoute, getTankRoute } from "../../common/utilities/RouteHelpers";
import { RouteContextType } from "../../hooks/use-route-context/UseRouteContext";
import { UIViewEnum } from "../../common/enums/UIViewEnum";
import OfflineDataService from "../../services/offline-data-service/OfflineDataService";
import { ObjectFeaturesEnum } from "../../common/enums/ObjectFeaturesEnum";
import { eLynxObjectTypeEnum } from "../../common/enums/eLynxObjectType";

export async function getOfflineFallbackRoute(customerID: number, routeContext: RouteContextType): Promise<string> {

    let url: string | undefined = undefined;


    switch (routeContext.contextObject?.objectType) {
        case eLynxObjectTypeEnum.Tag:
            // order in which these evaluated is important
            if (routeContext.tankID) {
                url = getTankRoute(UIViewEnum.Tank_Details, routeContext.groupID, routeContext.deviceID, routeContext.tankBatteryID, routeContext.tankID);
            } else if (routeContext.deviceID) {
                url = getDeviceRoute(UIViewEnum.Device_Details, routeContext.groupID, routeContext.wellID, routeContext.deviceID);
            } else if (routeContext.tankBatteryID) {
                url = getGroupRoute(UIViewEnum.Group_SummaryListing, routeContext.groupID as number);
            }

            break;

        case eLynxObjectTypeEnum.TankBattery:
        case eLynxObjectTypeEnum.Well:
        case eLynxObjectTypeEnum.Device:
        case eLynxObjectTypeEnum.Tank:

            // User Story 53209: Make Code Changes per GAS Report
            // SPR - This goofy crap doesn't even make sense, and I apparently wrote it. What the heck did I think it was
            // doing and what is it supposed to do?
            // ensure the object is available offline
            if (!(await OfflineDataService.getObject(customerID, routeContext.contextObject, -1 as ObjectFeaturesEnum))) {
                url = getGroupRoute(UIViewEnum.Group_SummaryListing, routeContext.groupID as number);
            }

            break;

        default:
            url = getGroupRoute(UIViewEnum.Group_SummaryListing, routeContext.groupID as number);
            break;
    }

    // something went wrong, default to summary listing
    if (!url) {
        url = getGroupRoute(UIViewEnum.Group_SummaryListing, routeContext.groupID as number);
    }

    return url;
}
